import React from 'react'
import ReactDOM from 'react-dom'
import { Theme } from '@twilio-paste/core/theme'

import './index.css'
import App from './App'

ReactDOM.render(
    <Theme.Provider theme='default'>
        <App configuration={window.appConfig} />
    </Theme.Provider>,
    document.getElementById('root')
)
